import converter from "../../../libs/number-to-words";
import common from "../../common";
import QuestionModel from "../../maths/QuestionModel";
import QuestionViewVerbal from "./QuestionViewVerbal";

export default class QuestionViewVerbalRatio extends QuestionViewVerbal {
    constructor(question) {
        super(question);
    }

    getHeaderText() {
        const data = P3.assets.json("templates");
        const name = data.template ? data.template : this._question.module;
        let templates = data["templates"][name][this._question.type];

        if (templates) {
            templates = templates.slice().filter(x => this.filterTemplate(x));
        }

        if (!templates || !templates.length) {
            return "ERROR: NO TEMPLATE FOUND";
        }

        this._template = P3.utils.selectRandom(templates);
        const words = data["words"];

        let text = this._template ? this._template.text : "";
        if (this._template) {
            const items = this.generateWords(this._template.text, words.items, /\[ITEM([0-9])?]/g);
            for (const i in items) {
                if (items.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), items[i]);
                }
            }

            const enemies = this.generateWords(this._template.text, words.enemies, /\[ENEMY([0-9])?]/g);
            for (const i in enemies) {
                if (enemies.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), enemies[i]);
                }
            }

            const friendlies = this.generateWords(this._template.text, words.friendly, /\[FRIENDLY([0-9])?]/g);
            for (const i in friendlies) {
                if (friendlies.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), friendlies[i]);
                }
            }

            const gems = this.generateWords(this._template.text, words.gems, /\[GEM([0-9])?]/g);
            for (const i in gems) {
                if (gems.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), gems[i]);
                }
            }

            const colours = this.generateWords(this._template.text, words.colours, /\[COLOUR([0-9])?]/g);
            for (const i in colours) {
                if (colours.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), colours[i]);
                }
            }

            const char_2 = this.generateWords(this._template.text, words.character_class_2, /\[CHARACTER_CLASS_TWO([0-9])?]/g);
            for (const i in char_2) {
                if (char_2.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), char_2[i]);
                }
            }

            const char_2_plural = this.generateWords(this._template.text, words.character_class, /\[CHARACTER_CLASS_PLURAL([0-9])?]/g);
            for (const i in char_2_plural) {
                if (char_2_plural.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), char_2_plural[i]);
                }
            }

            const spells = this.generateWords(this._template.text, words.spell_types, /\[SPELL([0-9])?]/g);
            for (const i in spells) {
                if (spells.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), spells[i]);
                }
            }

            const wordsVariants = P3.utils.selectRandom(words.item_variants);
            const itemVariants = this.generateWords(this._template.text, words.item_variants, /\[VARIANT([0-9])?]/g);
            for (const i in itemVariants) {
                if (itemVariants.hasOwnProperty(i)) {
                    if (i === "[VARIANT0]") {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), wordsVariants[0]);
                    }
                    else if (i === "[VARIANT1]") {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), wordsVariants[1]);
                    }
                    else if (i === "[VARIANT2]") {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), wordsVariants[2]);
                    }
                }
            }

            const ratioValues = this.generateRatioValues(this._template.text, /\[RVAL([0-9])?]/g);
            for (const i in ratioValues) {
                if (ratioValues.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), ratioValues[i]);
                }
            }

            const values = this.generateValues(this._template.text, /\[VALUE([0-9])?]/g);
            for (const i in values) {
                if (values.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), values[i]);
                }
            }
        }

        return text;
    }

    generateRatioValues(text, regex) {
        const values = {};

        let result = text.match(regex);
        if (result) {
            for (let i = 0; i < result.length; ++i) {
                const t = result[i];
                const match = t.match(/[0-9]/);
                const index = match ? parseInt(match[0]) : 0;
                const value = this._question.values[index].toString();
                if (!values[t]) {
                    values[t] = value;
                }
            }
        }
        return values;
    }

    isCorrect() {
        return this._inputValue.value === this._question.answer.value;
    }

    filterTemplate(x) {
        //todo - refactor this nicely
        if (this._question.plural !== undefined) {
            if (!this._question.plural) {
                if (!x.plural_indices) return false;
                else {
                    return (JSON.stringify(x.plural_indices.sort()) === JSON.stringify(this._question.pluralIndices.sort()));
                }
            } else {
                return x.plural === true || x.plural === undefined;
            }
        } else {
            return true;
        }
    }
}